import React from 'react';
import AdminModal from '../admin/AdminModal.js';
import OutOfOfficeControl from './OutOfOfficeControl.js';

const SetAvailabilityModal = ({ isOpen, onClose, onSave, user }) => (
  <AdminModal
    isOpen={isOpen && !!user}
    onClose={onClose}
    title="Set availability"
    containerClassName="modal-container availability-modal"
  >
    {user?.name && <p className="availability-modal-user">{user.name}</p>}
    <OutOfOfficeControl
      variant="modal"
      outOfOffice={user?.outOfOffice ?? null}
      onSave={onSave}
      onCancel={onClose}
    />
  </AdminModal>
);

export default SetAvailabilityModal;
